import { Paper, Stack, Typography } from "@mui/material";
import { useContext } from "react";
import SessionContext from "../contexts/session";
import { useTranslation, Trans } from "react-i18next";
import { isMobile, isTablet } from "react-device-detect";
import CountUp from "react-countup";
import { Grid } from "@mui/material";

export default function Dune() {
  const { selectedNetwork, settings } = useContext(SessionContext);
  const { t, i18n } = useTranslation();

  const duneStats = {
    //weekly_avg_unique_users: t("Weekly Avg Unique Users"),
    weekly_avg_txs: t("Weekly Avg Txs"),
    unique_players: t("Unique Players"),
    averagebetamount: t("Average Bet Amount"),
    bets: t("Bets"),
  };
  return (
    <>
      {selectedNetwork.dunePrefix && settings && !(isMobile || isTablet) && (
        <>
          <Typography variant="h6">
            <Trans t={t}>Dune Stats (updated every week)</Trans>
          </Typography>
          {(() => {
            duneStats[selectedNetwork.ui.symbol.toLowerCase()] =
              selectedNetwork.ui.symbol + " " + t("Bankroll");
            duneStats[selectedNetwork.ui.symbol.toLowerCase() + "profits"] =
              selectedNetwork.ui.symbol + " " + t("Profits");
          })()}

          <Grid
            container
            spacing={isTablet || isMobile ? 1 : 2}
            sx={{
              backgroundColor: "#404040",
              borderRadius: "10px",
              paddingInlineEnd: 2,
              paddingBlockEnd: 2,
            }}
          >
            {Object.keys(duneStats).map((statName) => (
              <Grid
                item
                xs={11}
                sm={4}
                lg={4}
                key={selectedNetwork.dunePrefix + "_" + statName}
              >
                <Stack
                  component={Paper}
                  variant="outlined"
                  spacing={2}
                  sx={{
                    flex: 2,
                    alignItems: "center",
                    p: 4,
                    backgroundColor: "#404040",
                    border: "1px solid grey",
                  }}
                >
                  <Stack sx={{ alignItems: "center" }}>
                    <Typography variant="h5">
                      {settings[selectedNetwork.dunePrefix + "_" + statName] ? (
                        (() => {
                          const value =
                            settings[
                              selectedNetwork.dunePrefix + "_" + statName
                            ];
                          const decimalPart = value.toFixed(3).split(".")[1];
                          const showDecimals =
                            decimalPart && parseInt(decimalPart) !== 0;
                          return (
                            <CountUp
                              decimals={showDecimals ? decimalPart.length : 0}
                              duration={3}
                              end={showDecimals ? value : value.toFixed(0)}
                            />
                          );
                        })()
                      ) : (
                        <CountUp
                          duration={3}
                          end={
                            settings[
                              selectedNetwork.dunePrefix + "_" + statName
                            ]
                          }
                        />
                      )}
                    </Typography>
                  </Stack>
                  <Typography>{duneStats[statName]}</Typography>
                </Stack>
              </Grid>
            ))}
          </Grid>
        </>
      )}
    </>
  );
}
